module.exports = __webpack_public_path__ + "img/default-m.e54f3259.png";